const isDevelopment = process.env.VUE_APP_ENV === 'development';
console.log('process.env.VUE_APP_ENV', process.env.VUE_APP_ENV)
const apiUrl = isDevelopment ? 'http://localhost:5001' : '';

export { apiUrl };